import { useRef, useCallback } from 'react';

const useThrottle = (fn, timeout = 300) => {
    const timerRef = useRef(undefined);
    if (!fn || typeof fn !== 'function') {
        throw new Error('As a first argument, you need to pass a function to useThrottle hook.');
    }
    return useCallback((...args) => {
        if (timerRef.current) {
            return;
        }
        timerRef.current = window.setTimeout(() => {
            window.clearTimeout(timerRef.current);
            timerRef.current = undefined;
        }, timeout);
        fn(...args);
    }, [timeout, fn, timerRef]);
};

export { useThrottle as default };
//# sourceMappingURL=useThrottle.js.map
